module.exports = __webpack_public_path__ + "static/icon-8f32c63d6a033f63cf418bcb8408d065.png";